import { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { handleOcorrenciaChange } from '../../../../../store/reducers/ocorrenciaSlice';
import { removerDuplicadosPor } from '../../../../../Utilitarios';
import CampoInputAutocompleteMultipleOptions from '../../../../shared/components/CampoInputComButton/CampoInputAutocompleteMultipleOptions/CampoInputAutocompleteMultipleOptions';
import EditItem from '../../../../shared/components/IconButtons/EditItem';
import VoidIcon from '../../../../shared/components/IconButtons/VoidIcon/VoidIcon';
import { useBuscaListaMarcas } from '../../../hooks/useBuscaListaMarcas';

const CampoInputMarcas = ({ editButton, disabled, onClick }) => {
    const [listaSemDuplicados, setListaSemDuplicados] = useState([])
    const { listaMarcas } = useBuscaListaMarcas()
    const { brands } = useSelector(state => state.ocorrenciaState)

    const dispatch = useDispatch()
    
    const handleChange = (name, values) => {
        dispatch(handleOcorrenciaChange({[name]: values}))
    }

    const handleClick = (e) => {
        e.preventDefault()
        onClick("brands")
    }

    useEffect(() => {
        if(listaMarcas.listaMarcas) {
            const novaLista = removerDuplicadosPor(marcas => marcas.name, listaMarcas.listaMarcas)
            setListaSemDuplicados(novaLista)
        }
    }, [listaMarcas])

    return (
        <CampoInputAutocompleteMultipleOptions
            titulo="Marcas*" 
            id="formAutocompleteMarca" 
            name="brands" 
            disabled={disabled}
            value={brands}
            getOptionLabel={option => option.name}
            renderOption={(props, option, state) => [props, option.name, state.id]}
            onChange={handleChange}
            multiple={true}
            listaAutocomplete={listaSemDuplicados} >
            {
                editButton === 'void' ? <VoidIcon /> : <></>
            }
            {
                editButton === 'edit' ? <EditItem onClick={handleClick} /> : <></>
            }
        </CampoInputAutocompleteMultipleOptions>
    )
}

export default memo(CampoInputMarcas)
